import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import SideNavigationComponent from "../../../components/widgets/sideNavigationComponent";
import TabsComponent from "../../../components/widgets/tabsComponent";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import WebSolutionsLayout from "./webSolutionsLayout";
import MobileSolutionsLayout from "./mobileSolutionsLayout";
import CloudSolutionsLayout from "./cloudSolutionsLayout";

const DigitalServicesTabView = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const digitalStudioList = [
        {label: t('services.home.list.web.label'), children: <WebSolutionsLayout />},
        {label: t('services.home.list.mobile.label'), children: <MobileSolutionsLayout />},
        {label: t('services.home.list.cloud.label'), children: <CloudSolutionsLayout />}
    ];

    const isLargeDevice = useMediaQuery(theme.breakpoints.up("lg"));

    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    const { hash } = useLocation();

    useEffect(() => {
        if(hash){
            console.log(hash);

            switch(hash){
                case "#web":
                    setSelectedTabIndex(0);
                    break;
                case "#mobile":
                    setSelectedTabIndex(1);
                    break;
                case "#cloud":
                    setSelectedTabIndex(2);
                    break;
                default:
                    document.location.hash = 'web';
                    setSelectedTabIndex(0);
                    break;
            }
        }
        else{
            document.location.hash = 'web';
            setSelectedTabIndex(0);
        }
    }, [hash]);

    const changeTabValues = useCallback((newValue) => {
        switch(newValue){
            case 0:
                document.location.hash = 'web';
                break;
            case 1:
                document.location.hash = 'mobile';
                break;
            case 2:
                document.location.hash = 'cloud';
                break;
            default:
                document.location.hash = 'web';
                break;
        }
    }, []);

    return (
        <>
            <Box
                sx={{
                    width: '100%'
                }}
            >
                {
                    isLargeDevice
                    ?
                    <SideNavigationComponent 
                        list={digitalStudioList}
                        manualIndex={selectedTabIndex}
                        customChangeFunction={changeTabValues}
                        tabsSx={{
                            width: 275
                        }}
                    />
                    :
                    <TabsComponent 
                        list={digitalStudioList}
                        manualIndex={selectedTabIndex}
                        customChangeFunction={changeTabValues}
                    />
                }
            </Box>
        </>
    );
}

export default DigitalServicesTabView;